import { AuthManager } from "../../component/auth/AuthContext";
import LabelizeApi, { LabelWorkflowBatch, LabelWorkflowStats } from "../../api/LabelizeApi";
import * as React from "react";
import { Component } from "react";
import { Button, Modal, ModalBody } from "reactstrap";
import MessageService from "../../service/MessageService";
import { RouteComponentProps } from "react-router";
import i18n from "i18next";

interface LabelizeWelcomeProps extends RouteComponentProps {
  authManager: AuthManager;
}

interface LabelizeWelcomeState {
  labelWorkflowBatches: LabelWorkflowBatch[];
  stats: LabelWorkflowStats[];
  obsInfoModal: boolean;
  lwbLoading: boolean;
  statLoading: boolean;
}

export default class LabelizeWelcome extends Component<LabelizeWelcomeProps, LabelizeWelcomeState> {
  private labelizeApi: LabelizeApi;

  constructor(props: LabelizeWelcomeProps) {
    super(props);
    this.labelizeApi = LabelizeApi.with(this.props.authManager.cancelableClient());
    this.state = { labelWorkflowBatches: [], obsInfoModal: false, lwbLoading: true, statLoading: true, stats: [] };
  }

  componentDidMount(): void {
    this.labelizeApi.findLabelWorkflowBatches().then((lwbs) => {
      this.setState({ labelWorkflowBatches: lwbs, lwbLoading: false });
    });
  }

  private toggleObsInfoModal() {
    this.setState((prevState) => {
      return { obsInfoModal: !prevState.obsInfoModal };
    });
  }

  render() {
    return (
      <div className="container">
        <h1>{i18n.t("labelize.title")}</h1>

        {this.state.lwbLoading && (
          <div>
            {i18n.t("global.loading")} <i className="fa fa-spinner fa-spin"></i>
          </div>
        )}

        {!this.state.lwbLoading && (
          <table className="table table-striped">
            <tbody>
              <tr>
                <th>{i18n.t("labelize.type")}</th>
                <th>{i18n.t("labelize.description")}</th>
                <th>{i18n.t("labelize.remainingExam")}</th>
                <th></th>
              </tr>
              {this.state.labelWorkflowBatches.map((lwb, idx) => {
                return (
                  <tr key={idx}>
                    <td>{lwb.labelWorkflowType}</td>
                    <td>
                      {lwb.label}{" "}
                      {lwb.labelWorkflowType == "OBS" && (
                        <i
                          title="Instructions"
                          className="fa fa-info-circle cursor-pointer"
                          onClick={() => this.toggleObsInfoModal()}
                        />
                      )}
                    </td>
                    <td>{lwb.studyCount}</td>
                    <td className="text-right">
                      <Button onClick={() => this.startWorkflow(lwb)} disabled={lwb.studyCount <= 0}>
                        {i18n.t("global.start")}
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}

        <h2>{i18n.t("labelize.monthStats")}</h2>

        <p>{i18n.t("labelize.unavailable")}</p>

        {/*{this.state.stats && this.state.stats.length > 0 &&*/}
        {/*<div>Du*/}
        {/*    {' '} <Moment format="DD/MM/YYYY">{this.state.stats[0].from}</Moment>*/}
        {/*    {' '} au {' '} <Moment format="DD/MM/YYYY">{this.state.stats[0].to}</Moment> inclus.*/}
        {/*</div> }*/}

        {/*{this.state.statLoading && <div>Chargement en cours <i className="fa fa-spinner fa-spin"/></div>}*/}

        {/*{!this.state.statLoading && <table className="table table-striped">*/}
        {/*    <tbody>*/}
        {/*    <tr>*/}
        {/*        <th>Workflow</th>*/}
        {/*        <th>Stats</th>*/}
        {/*    </tr>*/}
        {/*    {this.state.stats.map((stat, idx) => {*/}

        {/*        if (stat.obsStats.length > 0) {*/}
        {/*            return <tr key={"lwb-" + idx}>*/}
        {/*                <td>{stat.workflowLabel}</td>*/}
        {/*                <td>{stat.obsStats.map((st, idx) => {*/}
        {/*                    return <div key={"st-" + idx}>{st.state} : {st.count}</div>*/}
        {/*                })}*/}
        {/*                </td>*/}
        {/*            </tr>*/}
        {/*        }*/}

        {/*    })}*/}
        {/*    </tbody>*/}
        {/*</table>}*/}

        <Modal isOpen={this.state.obsInfoModal} toggle={() => this.toggleObsInfoModal()} size="lg">
          <ModalBody>
            <ModalBody>
              <p>
                <strong>{i18n.t("information.title")}</strong>
              </p>

              <p>{i18n.t("information.globalIdea")}</p>

              <ul>
                <li>
                  {i18n.t("information.multiObs")}
                  <ul>
                    <li>{i18n.t("information.multiObsDesc1")}</li>
                    <li>{i18n.t("information.multiObsDesc2")}</li>
                    <li>{i18n.t("information.multiObsDesc3")}</li>
                  </ul>
                </li>

                <li>
                  {i18n.t("information.bestPractices")}
                  <ul>
                    <li>{i18n.t("information.bestPracticesDesc1")}</li>
                    <li>{i18n.t("information.bestPracticesDesc2")}</li>
                    <li>
                      {i18n.t("information.areaType")}
                      <ul>
                        <li>{i18n.t("information.areaType1")}</li>
                        <li>{i18n.t("information.areaType2")}</li>
                        <li>
                          {i18n.t("information.areaType3")}
                          <ul>
                            <li>{i18n.t("information.blackArea1")}</li>
                            <li>{i18n.t("information.blackArea2")}</li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                    <li>{i18n.t("information.bestPracticesDesc3")}</li>
                  </ul>
                </li>

                <li>
                  {i18n.t("information.exclusionCases")}
                  <ul>
                    <li>{i18n.t("information.exclusionCasesDesc1")}</li>
                    <li>{i18n.t("information.exclusionCasesDesc2")}</li>
                    <li>{i18n.t("information.exclusionCasesDesc3")}</li>
                  </ul>
                </li>
              </ul>
            </ModalBody>
          </ModalBody>
        </Modal>
      </div>
    );
  }

  private startWorkflow(lwb: LabelWorkflowBatch) {
    const params = new URLSearchParams();
    params.append("lbId", lwb.labelBatchId);
    params.append("lwId", lwb.labelWorkflowId);
    const paramsStr = params.toString();

    if (lwb.labelWorkflowType == "OBS") {
      this.props.history.push("/labelize-obs?" + paramsStr);
    } else if (lwb.labelWorkflowType == "PART_PARAM") {
      this.props.history.push("/labelize-part-params?" + paramsStr);
    } else {
      MessageService.error("Impossible");
    }
  }
}
